// Auto-generated normalizer for table: CuestionariosPreguntas
export function cuestionariosPreguntasNormalize(row) {
  return {
    idCuestionarioPreguntas: row.idCuestionarioPreguntas ?? row.IdCuestionarioPreguntas ?? row['IdCuestionarioPreguntas'] ?? 0,
    idCuestionario: row.idCuestionario ?? row.IdCuestionario ?? row['IdCuestionario'] ?? 0,
    idTipoPregunta: row.idTipoPregunta ?? row.IdTipoPregunta ?? row['IdTipoPregunta'] ?? 0,
    descripcionPregunta: row.descripcionPregunta ?? row.DescripcionPregunta ?? row['DescripcionPregunta'] ?? '',
    retroalimentacionoContexto: row.retroalimentacionoContexto ?? row.RetroalimentacionoContexto ?? row['RetroalimentacionoContexto'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
